import { tv } from 'tailwind-variants'

export const documentCardInfoVariants = tv({
  slots: {
    container: 'flex flex-row truncate',
    cardContainer: 'flex flex-row w-full justify-between truncate',
    infos: 'flex flex-col truncate',
    title: 'font-bold text-secondary-xdark truncate',
    subtitle: 'text-sub text-secondary-medium',
    icon: 'flex text-deca text-primary-medium'
  },
  variants: {
    isReply: {
      true: {
        icon: 'text-primary-xdark'
      }
    }
  }
})
